// extracted by mini-css-extract-plugin
export default {"quill":"QuillEditor_quill__RRRG6","ql-picker-label":"QuillEditor_ql-picker-label__uYI+a"};